import React from "react";
import FAQAccordion from '../FAQAccordion';

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {
    return (
      <React.Fragment>
        <section id="info-colorado-river" className="about-us pt-trip gray-light-bg">
          <div className="container">
            <div className="row justify-content-center">
              <div>
                <div className="section-heading mb-5 mx-2">
                  {this.props.showTitle && this.props.showTitle === true && (
                    <title className="badge badge-primary badge-pill">
                      How to Plan a Sustainable Hiking Trip?
                    </title>
                  )}
                  <h1 className="text-center">
                    How to Plan a Sustainable Hiking Trip (Complete Guide) <br />
                  </h1>
                <p>Hiking lets us experience some of the most beautiful places on Earth. Alpine lakes, forests, mountain peaks, and quiet trails remind us why nature matters. But the truth is simple. The more people explore the outdoors, the more important it becomes to travel responsibly.</p>
<p>Planning a sustainable hiking trip helps protect the trails we love so future hikers can enjoy them too.</p>
<p>If you would rather explore with a guide, you can join my <a class="in-text-link" href="https://www.airbnb.com/experiences/4670214?s=67&unique_share_id=5260d3e2-6b0d-4b14-9a9d-5a3f48aa93c7">Guided Hiking Experience</a>. I designed it specifically for people who want to see one of Washington’s most beautiful alpine trails while learning responsible hiking practices and Leave No Trace principles.</p>
                <FAQAccordion
                  title="Sustainable Hiking Trip FAQs"
                  items={[
                    { q: "What are the Leave No Trace principles for hiking?", a: "The seven LNT principles are: plan ahead and prepare, travel on durable surfaces, dispose of waste properly, leave what you find, minimize campfire impacts, respect wildlife, and be considerate of other visitors." },
                    { q: "How do I reduce my impact when hiking popular trails?", a: "Stay on the main trail — widening or cutting switchbacks destroys vegetation. Hike early or on weekdays. Choose permits-required trails that manage visitor numbers. Camp at designated sites only." },
                    { q: "What is the most sustainable way to get to a trailhead?", a: "Carpooling and shuttle buses reduce the biggest impact — private vehicle emissions and trailhead parking congestion. Many popular parks now offer park-and-ride shuttles. Consider staying locally to reduce driving distance." },
                    { q: "How should I dispose of human waste in the backcountry?", a: "Use WAG bags in high-use areas or where regulations require pack-out. Otherwise, dig a cat hole 6-8 inches deep, at least 200 feet from water, trails, and camp. Pack out toilet paper in a sealed bag." },
                    { q: "What are the most eco-friendly foods to bring hiking?", a: "Minimize single-use packaging — use reusable containers. High calorie-to-weight foods like nuts, dried fruit, and nut butter have a lower carbon footprint than processed freeze-dried meals. Avoid excess packaging that becomes trail waste." },
                    { q: "How can I support trail conservation when hiking?", a: "Buy an America the Beautiful pass ($80/year) — proceeds fund federal lands. Volunteer with local trail maintenance organizations. Follow park rules, report trail damage, and donate to groups like the American Hiking Society or local trail associations." },
                  ]}
                />
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
export default About;